import { useAppHeaderObserver } from 'hooks/useAppLayoutObservers'
import React, { useRef } from 'react'
import NavBarGlobalBar from './NavBarGlobalBar'
import NavBarTertiaryBar from './NavBarTertiaryBar'
import NavBarUtilBar from './NavBarUtilBar'
import styled from 'styled-components'

const NavBarContainer = styled.div`
  position: relative;

  @media print {
    display: none;
  }
`

function NavBar() {
  const ref = useRef<HTMLDivElement>(null)
  useAppHeaderObserver(ref)

  return <NavBarContainer ref={ref} data-testid="navbar">
    <NavBarTertiaryBar />
    <NavBarUtilBar />
    <NavBarGlobalBar />
  </NavBarContainer>
}

export default React.memo(NavBar)
